import { useCallback } from "react";

import { useSetAtom } from "jotai";

import { columnWidthsAtom } from "../atoms/fieldGroupAtoms";

/**
 * Update column width in the width tracking map
 */
export function resizeColumnInMap(
  currentMap: Map<string, number>,
  columnId: string,
  width: number
): Map<string, number> {
  const next = new Map(currentMap);
  next.set(columnId, width);
  return next;
}

/**
 * Hook for handling column resize operations
 */
export function useColumnResize() {
  const setColumnWidths = useSetAtom(columnWidthsAtom);

  const onColumnResize = useCallback(
    (column: { id?: string }, newSize: number) => {
      if (column.id) {
        setColumnWidths((prev) => resizeColumnInMap(prev, column.id as string, newSize));
      }
    },
    [setColumnWidths]
  );

  return { onColumnResize };
}
